import { Component, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { interval, Subscription, takeWhile, tap } from 'rxjs';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';
import { AppButton } from 'src/app/shared/button/app-button';
import { TranslationService } from '../../configuration/translation-service';
import { JwtService } from '../../jwt/jwt-service';

@Component({
  selector: 'app-session-timeout-dialog',
  imports: [AppButton, TranslationPipe, DialogModule],
  templateUrl: './session-timeout-dialog.html',
  styleUrl: './session-timeout-dialog.scss'
})
export class SessionTimeoutDialog {
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);
  jwtService = inject(JwtService);
  translationService = inject(TranslationService);

  private TIMEOUT_MINUTES: number | null = null;
  countdown: number = 0;
  private sub!: Subscription;

  ngOnInit() {
    this.config.header = this.translationService.translate('SESSION_TIMEOUT');

    this.TIMEOUT_MINUTES = this.getFromLocalStorage();
    // this.TIMEOUT_MINUTES = 0.1; // FOR TEST
    if (!this.TIMEOUT_MINUTES) return;

    this.countdown = this.TIMEOUT_MINUTES * 60;

    // run a countdown every second
    this.sub = interval(1000)
      .pipe(
        takeWhile(() => this.countdown > 0),
        tap(() => {
          this.countdown--;

          if (this.countdown <= 0) {
            this.ref.close('timeout');
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onStayLoggedIn() {
    this.ref.close('stay');
  }

  getFromLocalStorage() {
    const loginInfo = this.jwtService.getClaims();
    if (!loginInfo) return null;

    return Number(loginInfo.warningmsgdisplayduration);
  }
}
